import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { RecoilRoot } from 'recoil'

import ErrorBoundary from './components/ErrorBoundary'
import initFirebase from './db/initFirebase'
import App from './pages/App'
import Error from './pages/Error'

// material ui theme

// fonts - material ui was built with roboto in mind
import 'typeface-roboto'

// some global css
import './index.css'

initFirebase.init()

const root = createRoot(document.getElementById('root')!)

root.render(
  <>
    <BrowserRouter>
      <RecoilRoot>
        <ErrorBoundary onError={console.log} errorComponent={<Error />}>
          <App />
        </ErrorBoundary>
      </RecoilRoot>
    </BrowserRouter>
  </>
)
